import { useMemo } from "react";
import { graphql, useLazyLoadQuery } from "react-relay";
import { buildReference } from "./nflToolFilters";

const REFERENCE_QUERY = graphql`
  query useNflReferenceQuery {
    whoAmI {
      username
      groups {
        name
      }
    }

    nflStatSeasons {
      id
      year
      current
      nflstatweekSet(first: 30) {
        edges {
          node {
            week
            current
          }
        }
      }
    }

    nflStatTeams {
      id
      city
      name
      abbreviation
      primaryColorHex
      logoSrc
    }
  }
`;

export default function useNflReference({ fetchKey } = {}) {
  const data = useLazyLoadQuery(
    REFERENCE_QUERY,
    {},
    { fetchKey, fetchPolicy: fetchKey > 0 ? "network-only" : "store-or-network" }
  );
  return useMemo(() => buildReference(data), [data]);
}
